const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || ''
const FACEBOOK_ADMINS = process.env.NEXT_PUBLIC_FACEBOOK_ADMINS || ''

const buildDescription = ({ labelTerm }: Record<string, string>) => {
  return `Julgados selecionados pelo Jus IA para a tese ${labelTerm}.`
}

export const getMetaTags = ({ title, labelTerm, canonicalUrl }: Record<string, string>) => {
  const description = buildDescription({ labelTerm })
  return [
    { property: 'fb:app_id', content: FACEBOOK_APP_ID },
    { property: 'fb:admins', content: FACEBOOK_ADMINS },
    { property: 'og:url', content: canonicalUrl },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: title },
    {
      property: 'og:image',
      content: 'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-675.png',
    },
    { property: 'og:image:type', content: 'image/png' },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '675' },
    { property: 'og:image:alt', content: title },
    { property: 'og:locale', content: 'pt_BR' },
    { property: 'og:description', content: description },
    { property: 'og:site_name', content: 'Jusbrasil' },
    { name: 'description', content: description },
  ]
}
